<template>
  <div class="warp">
    <div class="ipt">
      <el-input v-model="url" placeholder="请输入音频地址"></el-input>
      <el-button 
      type="primary" 
      size="mini" 
      v-if="!isPlay"
      @click="play()"
      circle>
        <i class="iconfont icon-bofang1" style="font-size: 12px;"></i>
      </el-button>
      <el-button 
      type="primary" 
      size="mini" 
      v-if="isPlay"
      @click="pause()"
      circle>
        <i class="iconfont icon-zanting1" style="font-size: 12px;"></i>
      </el-button>
    </div>
    <audio ref="mp3" @ended="audioEnded" @play="onPlay" @pause="onPause" controls style="display: none"></audio>
  </div>
</template>

<script>
import { Message } from 'element-ui';

export default {
  name: 'Login',
  components: {
    // ShInput,
    // ShButton
  },
  data() {
    return {
      url: '',
      isPlay: false
    }
  },
  methods: {
    play () {
      if(!this.url) {
        Message.error('请输入音频地址')
        return
      }
      let dom = this.$refs.mp3
      dom.pause()
      dom.src = this.url
      dom.play()
    },
    pause () {
      let dom = this.$refs.mp3
      dom.pause()
    },
    onPlay () {
      this.isPlay = true
    },
    onPause () {
      this.isPlay = false
    },
    audioEnded () {
      console.log('end')
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.warp {
  width: 100%;
  // height: calc(100% - 246px);
  padding: 200px 0;
  .ipt {
    width: 600px;
    padding: 80px;
    border-radius: 10px;
    overflow: hidden;
    background-color: #182760;
    margin: 0 auto;
    &>div {
      margin: 5px 0;
    }
    button {
      margin-top: 20px;
    }
  }
}
@media (max-width: 767px) {
  .warp {
    padding: 200px 20px;
    .ipt {
      width: 100%;
    }
  }
}
</style>
